import { getRemovebgLogs as getRemovebgLogsApi } from '../../api/analytics3d';
import {createAsyncThunk} from "@reduxjs/toolkit";
import store from "../../store";
import {setNotifications} from "../slices/notifications";

export const getRemovebgLogs = createAsyncThunk(
    'removebgLogs/getRemovebgLogs',
    async (queryParams: any, {rejectWithValue}) => {
        try {
            const logs = await getRemovebgLogsApi(queryParams);
            return logs;
        } catch (error: any) {
            store.dispatch(setNotifications({text: error.message, type: 'error'}))
            return rejectWithValue(error.message)
        }
    }
); 